import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/joy'

const CellStatus = ({ type = 'status', value }) => {

	const { t } = useTranslation()

	return (
		<Box className={'list-element-cell' + (type && ' cell-'+type.toLowerCase())}>
			{value && <span className={'status' +  (value && ' status-'+value.toLowerCase())}>{t(value)}</span>}
		</Box>
	)
}

export default CellStatus
